import Swiper from 'swiper';
// eslint-disable-next-line import/no-unresolved -- is resolved correctly...
import 'swiper/css';
import { Navigation, Pagination } from 'swiper/modules';
import { sliderConfigurations } from './slider_configuration';

// error
if (sliderConfigurations.length === 0) {
	console.warn('Slider Configuration File missing...Check JS');
}

// initialize each slider type
for (const currentConfig of sliderConfigurations) {
	const { config, options, callbacks } = currentConfig;
	const containers = document.querySelectorAll(
		`[data-slider-identifier="${config.selector}"]`,
	);

	for (let j = 0; j < containers.length; j++) {
		const container = containers[j];
		container.setAttribute('data-slider-container-index', j);

		/** @type {HTMLElement} */
		const sliderElement = container.querySelector(
			`[data-slider-wrapper="${config.selector}"]`,
		);
		sliderElement.dataset.sliderIndex = `${j}`;

		const slider = new Swiper(sliderElement, {
			init: false,
			modules: [Navigation, Pagination],
			direction: 'horizontal',
			...options,
			navigation: {
				prevEl: container.querySelector(options.prevButton),
				nextEl: container.querySelector(options.nextButton),
			},
		});

		const {
			init = [],
			slideChange = [],
			transitionEnd = [],
			resize = [],
		} = callbacks;
		for (const name of init) {
			slider.on('init', getFunction(name, container, currentConfig, slider));
		}
		slider.init();

		for (const name of transitionEnd) {
			slider.on(
				'transitionEnd',
				getFunction(name, container, currentConfig, slider),
			);
		}
		for (const name of slideChange) {
			slider.on(
				'slideChangeTransitionEnd',
				getFunction(name, container, currentConfig, slider),
			);
		}
		for (const name of resize) {
			slider.on('resize', getFunction(name, container, currentConfig, slider));
		}
	}
}

/**
 * @typedef {'refreshAdditionalContent'|'initializeFilter'|'refreshFilterStatus'|'refreshSlider'} SliderFunctionName
 */

/**
 * @param {SliderFunctionName} name
 * @param {HTMLElement} container
 * @param {Object} config
 * @param {Swiper} slider
 * @returns {Function}
 */
function getFunction(name, container, config, slider) {
	const params = { container, config, slider };
	switch (name) {
		case 'refreshAdditionalContent':
			return () => refreshAdditionalContent(params);
		case 'refreshSlider':
			return () => refreshSlider(params);
		default:
			throw new Error(`Unexpected function name "${name}"`);
	}
}

/**
 * refresh Top/Bottom Content Parts equal to active slider index
 */
function refreshAdditionalContent({ container, config: { config }, slider }) {
	const additionalContent = container.querySelectorAll(
		`[data-slider-additional-content="${config.selector}"]`,
	);
	const { slidesPerView } = slider.params;
	for (const content of additionalContent) {
		const maxIndex = getMaxSlideIndex(container, config);
		for (const item of content.querySelectorAll('li')) {
			item.classList.remove('slider-additional-content--element-active');
		}

		// Beim Produkt Slider ist (ab Breakpoint LG) nicht der aktive Slide im Vordergrund,
		// sondern "Slide-Prev", deshalb muss auch der zugehörige Text anders ermittelt werden
		// Unter Breakpoint LG ist es beim Produkt Slider wieder eine 1:1 Relation von Bild und Text
		const offset = slidesPerView > 1 ? 1 : 0;
		const index =
			slider.realIndex + offset > maxIndex ? 0 : slider.realIndex + offset;
		for (const element of content.querySelectorAll(`[data-index="${index}"]`)) {
			element.classList.add('slider-additional-content--element-active');
		}
	}
}

/** refresh slider on resize */
function refreshSlider({ slider, container, config: { config } }) {
	slider.update();
	const { slidesPerView } = slider.params;
	const highestIndex = getMaxSlideIndex(container, config);

	// index des aktiven Slides
	let { realIndex } = slider;

	// Unter Breakpoint LG ist es beim Produkt Slider wieder eine 1:1 Relation von Bild und Text - die Logik ist hier umgedreht im Vergleich zu der Funktion refreshAdditionalContent
	const increaseRealIndex = slidesPerView <= 1;

	// ermittele den wirklich anzuzeigenden Slide
	realIndex = increaseRealIndex
		? realIndex + 1 > highestIndex
			? 0
			: realIndex + 1
		: realIndex;

	// TODO OMG...:
	// Bugfix: Es scheint ein Bug zu sein !?! Nach einem Resize wird bei slideTo nicht zu der angegebenen Position geslidet sondern zu der Position--
	realIndex = realIndex + 1 > highestIndex ? 0 : realIndex + 1;

	// gehe zu neu ermittelter Position
	slider.slideToLoop(realIndex);
}

/**
 * get the maximum slide index
 */
function getMaxSlideIndex(container, config) {
	return Math.max(
		...Array.from(
			container.querySelectorAll(
				`[data-slider-additional-content="${config.selector}"]`,
			),
		)
			.flatMap((content) => Array.from(content.querySelectorAll('li')))
			.map((item) => Number.parseInt(item.dataset.index)),
	);
}
